import { axios } from '../../utils/request'
import path from "../../api/path";


export function getUserInfo () {
    const url = '/' + path.locService + '/user-info'
    return axios({
        url: url,
        method: 'get'
    })
}

export function uploadSession(param) {
    const url = '/' + path.locService + '/adfs/local'
    return axios({
        url: url,
        method: 'post',
        data: param
    })
}

